export enum DeleteRegistrationResultEnum {
  None = 0,
  Success = 1,
  Failure = 2,
  SuccessWithWarnings = 3,
  UnappliedPaymentCreated = 4,
  RefundProcessed = 8,
  RefundFailed = 16,
}
